import {SagaIterator} from 'redux-saga';
import {all, call, fork} from 'redux-saga/effects';

import {logWithSentry} from 'libs/sentry/sentry';

import cartQuoteSaga from './cart/cart';
import cartUIReactionsSaga from './cartUIReactions/cartUIReactions';
import dynamicYieldSagaCart from './dynamicYieldCart/dynamicYieldCart';
import dynamicYieldCartContext from './dynamicYieldCartContext/dynamicYieldCartContext';
import {applePayExpressPaymentSaga} from './payments/applePayExpress/applePayExpress';
import {payPalExpressPaymentSaga} from './payments/paypalExpress/payPalExpress';
import placeOfInteractionSaga from './placeOfInteraction/placeOfInteraction';
import cartSpecialOfferSaga from './specialOffer/specialOffer';
import cartUhcSaga from './uhc/uhc';
import updateCartSaga from './updateCart/updateCart';

/**
 * Begin of saga
 */
export default function* cartRootSaga(): SagaIterator {
    try {
        yield all([
            fork(cartQuoteSaga),
            call(cartUhcSaga),
            fork(updateCartSaga),
            call(cartSpecialOfferSaga),
            fork(dynamicYieldSagaCart),
            fork(dynamicYieldCartContext),
            fork(cartUIReactionsSaga),
            fork(placeOfInteractionSaga),
            fork(applePayExpressPaymentSaga),
            fork(payPalExpressPaymentSaga),
        ]);
    } catch (error) {
        logWithSentry(new Error('Cart saga failed'), {
            error,
        });
    }
}
